import { render, staticRenderFns } from "./IframeRelay.vue?vue&type=template&id=3421ebb1&scoped=true"
import script from "./IframeRelay.vue?vue&type=script&lang=js"
export * from "./IframeRelay.vue?vue&type=script&lang=js"
import style0 from "./IframeRelay.vue?vue&type=style&index=0&id=3421ebb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421ebb1",
  null
  
)

export default component.exports